<cerrix-loader [cerrixTab]="tab"></cerrix-loader>

<ng-template #customMenu>
    <div class="node m-3">
        <i class="fa-fw fas fa-trash"></i>
        <b>Deleted Items</b>
    </div>
    @for (node of menuItems; track node) {
        <ng-container
            *ngTemplateOutlet="nodeTemplate; context: { node: node, parent: null, depth: 0 }"
        >
        </ng-container>
    }
</ng-template>

<ng-template #nodeTemplate let-node="node" let-parent="parent" let-depth="depth">
    <div class="node" [class.selected]="selectedMenuItem && node === selectedMenuItem">
        <div class="node-detail" [title]="node.name" [attr.data-uiid]="'tabmenu-item-' + node.name">
            <div class="node-child-toggler" data-uiid="toggle-node">
                @if (node.children.length > 0) {
                    <i
                        class="fas fa-angle-{{ node.isExpanded ? 'down' : 'right' }}"
                        (click)="node.isExpanded = !node.isExpanded"
                    ></i>
                }
            </div>
            <div class="node-icon" (click)="nodeClicked(node)">
                <cerrix-icon-viewer
                    [icon]="node.icon"
                    appendClass="fa-fw"
                    [defaultColor]="'#FFFFFF'"
                ></cerrix-icon-viewer>
            </div>
            <div
                class="node-name"
                (click)="nodeClicked(node)"
                [attr.data-uiid]="
                    node.children.length > 0 ? '' : 'tabmenu-item-' + node.name + '-node'
                "
            >
                {{ node.name }}
            </div>
        </div>
        @if (node.isExpanded && node.children.length > 0) {
            <div class="children">
                @for (child of node.children; track child) {
                    <ng-container
                        *ngTemplateOutlet="
                            nodeTemplate;
                            context: { node: child, parent: node, depth: depth + 1 }
                        "
                    >
                    </ng-container>
                }
            </div>
        }
    </div>
</ng-template>

@if (configLoaded) {
    <generic-list-manager [config]="config" [skipReloadConfirm]="true"></generic-list-manager>
} @else {
    <div class="fancy-loader"></div>
}
